<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading8">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse8" aria-expanded="false" aria-controls="collapse8">
                Ondernemersaftrek
            </button>
        </h2>
        <div id="collapse8" class="accordion-collapse collapse" aria-labelledby="heading8"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                De ondernemersaftrek bestaat uit:
                <li class="list">zelfstandigenaftrek</li>
                <li class="list">startersaftrek</li>
                <li class="list">startersaftrek bij arbeidsongeschiktheid</li>
                <li class="list">meewerkaftrek</li>
                <li class="list">stakingsaftrek</li>
                <li class="list">aftrek voor speur- en ontwikkelingswerk</li>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading11">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse11" aria-expanded="false" aria-controls="collapse11">
                Urencriterium
            </button>
        </h2>
        <div id="collapse11" class="accordion-collapse collapse" aria-labelledby="heading11"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Het urencriterium betekent dat je minimaal 1.225 uren in een jaar besteedt aan je onderneming. Deze
                drempel bepaalt of je in aanmerking komt voor bepaalde belastingvoordelen zoals de ondernemersaftrek.
                <div class="space10"></div>

                <b>Voorwaarden</b><br/>
                Je voldoet aan het urencriterium als je aan de volgende 2 voorwaarden voldoet:
                <li class="list">je besteedt als ondernemer in het kalenderjaar minimaal 1.225 uur aan het feitelijk
                    drijven van de
                    onderneming(en).
                </li>
                <li class="list">je besteedt meer tijd aan de onderneming dan aan andere werkzaamheden (bijvoorbeeld in
                    loondienst).
                    Was je in 1 van de jaren {{ this.year - 5 }} tot en met {{ this.year - 1 }} geen ondernemer? Dan
                    hoef je niet te voldoen aan deze tweede voorwaarde.
                </li>

                <div class="space10"></div>
                Let op! Onderbreek je je werk als ondernemer door je zwangerschap? Dan tellen de
                niet-gewerkte uren over totaal 16 weken toch mee als gewerkte uren.

                <div class="space10"></div>
                Let op! Ben je niet het hele jaar ondernemer? Bijvoorbeeld omdat je in de loop van het jaar bent
                gestart? Dan moet je in dat jaar toch minimaal 1.225 uur aan de onderneming(en) besteden. Je mag niet de
                1.225 uur
                herrekenen naar de periode dat je ondernemer bent.
                <div class="space10"></div>

                <u>Voorbeeld</u><br/>
                Je start op 1 juli, dus je bent in dat jaar 6 maanden ondernemer. Je mag dan niet uitgaan van 6/12
                keer 1.225 uur, maar je moet in die 6 maanden minimaal 1.225 uur besteden aan de onderneming(en).
                <div class="space10"></div>

                <b>Uren die niet meetellen</b><br/>
                Maak je als ondernemer deel uit van een samenwerkingsverband (maatschap of vennootschap onder firma)
                met huisgenoten, of met bloed- of aanverwanten in de rechte lijn of hun huisgenoten (de zogeheten
                verbonden personen)? Dan tellen de gewerkte uren niet mee voor het urencriterium in de volgende
                situaties:
                <li class="list">het samenwerkingsverband is ongebruikelijk en je doet voor 70% of meer ondersteunende
                    werkzaamheden.
                </li>
                <li class="list">Een samenwerkingsverband is ongebruikelijk als niet-verbonden personen zo'n
                    samenwerkingsverband
                    niet zouden aangaan. Bijvoorbeeld een vennootschap onder firma tussen een tandarts en zijn
                    assistente.
                </li>
                <li class="list">De verbonden personen genieten winst als ondernemer, maar jijzelf niet. Bijvoorbeeld
                    bij een
                    ondermaatschap.
                </li>
                <div class="space10"></div>

                <b>Verlaagd-urencriterium</b><br/>
                Het verlaagd-urencriterium is 1 van de voorwaarden voor het krijgen van de startersaftrek bij
                arbeidsongeschiktheid. Het houdt in dat je als ondernemer minimaal 800 uur besteedt aan het feitelijk
                drijven vanjeonderneming(en), maar niet meer dan 1.225 uur.

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading0">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse0" aria-expanded="false" aria-controls="collapse0">
                Zelfstandigenaftrek
            </button>
        </h2>
        <div id="collapse0" class="accordion-collapse collapse" aria-labelledby="heading0"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>Voorwaarde</b><br/>
                De ondernemer die in het aangifte minimaal 1.225 uur besteedt aan het feitelijk drijven van zijn
                onderneming(en) heeft recht op een extra aftrekpost, de zelfstandigenaftrek. <br/>
                De zelfstandigenaftrek die je van de winst kunt aftrekken, kan niet hoger zijn dan de winst vóór
                ondernemersaftrek, tenzij je de startersaftrek krijgt.
                <div class="space10"></div>

                Je krijgt geen zelfstandigenaftrek over de winst die je behaalt als medegerechtigde.
                <div class="space10"></div>

                Onderbreekt een onderneemster haar werk door haar zwangerschap? Dan tellen de niet-gewerkte uren over
                totaal 16 weken toch mee als gewerkte uren.
                <div class="space10"></div>

                Let op! Je mag de 1.225 uur niet herrekenen naar de periode van ondernemerschap.<br/>
                <u>Voorbeeld</u><br/>
                Je bent ondernemer en je start op 1 juli. Je bent in dat jaar dus 6 maanden ondernemer. Je mag dan niet
                uitgaan van 6/12 keer 1.225 uur, maar je moet in die 6 maanden minimaal 1.225 uur hebben besteed aan de
                onderneming(en).
                <div class="space10"></div>
                <b>De winst is lager dan het bedrag van de zelfstandigenaftrek</b><br/>
                Is de winst vóór ondernemersaftrek in dit boekjaar lager dan het bedrag van de zelfstandigenaftrek? Dan
                kun je de zelfstandigenaftrek niet helemaal verrekenen. Het deel van de
                zelfstandigenaftrek dat je niet kunt verrekenen (de niet-gerealiseerde zelfstandigenaftrek) kun je
                verrekenen in de volgende 9 jaar. De winst moet in die jaren dan wel hoger zijn dan de
                zelfstandigenaftrek van die jaren. Ook moet je in die jaren wel recht hebben op de zelfstandigenaftrek.
                <div class="space10"></div>

                <b>Niet-gerealiseerde zelfstandigenaftrek uit vorige jaren verrekenen</b><br/>
                Is de winst vóór ondernemersaftrek in dit boekjaar hoger dan het bedrag van de zelfstandigenaftrek? En
                heb je niet-gerealiseerde zelfstandigenaftrek uit vorige jaren? Dan kun je deze niet-gerealiseerde
                zelfstandigenaftrek in dit jaar verrekenen. Het maximale bedrag dat je kunt verrekenen is het bedrag
                waarmee de winst uitkomt boven de zelfstandigenaftrek van dit jaar.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading14">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse14" aria-expanded="false" aria-controls="collapse14">
                Restant zelfstandigenaftrek voorgaande jaren
            </button>
        </h2>
        <div id="collapse14" class="accordion-collapse collapse" aria-labelledby="heading14"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                De restant zelfstandigenaftrek is het deel van de zelfstandigenaftrek dat je in een bepaald jaar niet
                volledig kunt gebruiken omdat je winst te laag is. Je mag dit niet-gebruikte deel dan doorschuiven naar
                een volgend jaar. Dit doorgeschoven bedrag heet de restant zelfstandigenaftrek.

                <div class="space10"></div>
                <b>Wanneer krijg je hiermee te maken?</b><br/>
                Als je als ondernemer in een jaar niet genoeg winst hebt om de volledige zelfstandigenaftrek
                af te trekken, dan blijft er een deel over dat je nog tegoed hebt. Dit wordt dus de restant
                zelfstandigenaftrek, en die kun je in toekomstige jaren alsnog aftrekken, mits je
                dan voldoende winst hebt.
                <div class="space10"></div>
                <b> Waar vind je de restant zelfstandigenaftrek?</b><br/>
                Je kunt het restant vinden op je aanslagbrief of definitieve belastingaangifte van de Belastingdienst.
                In de bijlage bij je aanslag staat vaak het bedrag van de restant zelfstandigenaftrek dat naar het
                volgende jaar is overgeheveld.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Startersaftrek
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>Voorwaarden</b><br/>
                De zelfstandigenaftrek wordt verhoogd met een startersaftrek in de volgende situatie:
                <li class="list">je was in 1 of meer van de 5 voorafgaande kalenderjaren geen ondernemer.</li>
                <li class="list">je paste in die periode niet meer dan 2 keer zelfstandigenaftrek toe.</li>
                <div class="space10"></div>

                De startersaftrek is een vast bedrag (of 50% als je aan het begin van het kalenderjaar de AOW-leeftijd
                hebt bereikt).
                <div class="space10"></div>
                Komt de ondernemer voor de startersaftrek in aanmerking, dan telt dit bedrag op bij het bedrag van de
                zelfstandigenaftrek. Het kan zijn dat de zelfstandigenaftrek en de startersaftrek bij elkaar hoger zijn
                dan de winst. Je hebt dan een te verrekenen verlies.

                <div class="space10"></div>
                <b>Startersaftrek bij arbeidsongeschiktheid</b><br/>
                Je krijgt de startersaftrek bij arbeidsongeschiktheid als je voldoet aan elk van de volgende
                voorwaarden:
                <li class="list">je hebt aan het begin van het kalenderjaar nog niet de AOW-leeftijd bereikt.</li>
                <li class="list">je bent ondernemer voor de inkomstenbelasting.</li>
                <li class="list">je was in 1 of meer van de 5 voorgaande kalenderjaren geen ondernemer voor de
                    inkomstenbelasting.
                </li>
                <li class="list">je kunt een arbeidsongeschiktheidsuitkering krijgen.</li>
                <li class="list">je voldoet niet aan het urencriterium, maar wel aan het verlaagd-urencriterium. Zie
                    'Urencriterium'.
                </li>
                <li class="list">Er was in de 5 voorgaande kalenderjaren geen sprake van een geruisloze terugkeer uit
                    een bv.
                </li>
                <li class="list">je krijgt geen startersaftrek bij arbeidsongeschiktheid over de winst die je behaalt
                    als
                    medegerechtigde.
                </li>
                <div class="space10"></div>
                De startersaftrek bij arbeidsongeschiktheid is mede afhankelijk van het aantalvoorafgaande jaren dat je
                gebruik hebt gemaakt van deze aftrek.
            </div>
        </div>

    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading10">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse10" aria-expanded="false" aria-controls="collapse10-">
                Meewerkaftrek
            </button>
        </h2>
        <div id="collapse10" class="accordion-collapse collapse" aria-labelledby="heading10"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>Voorwaarde</b><br/>
                Een ondernemer met een fiscaal partner krijgt de meewerkaftrek als hij voldoet aan de volgende
                voorwaarden:
                <li class="list">hij is bent ondernemer voor de inkomstenbelasting.</li>
                <li class="list">hij voldoet aan het urencriterium.</li>
                <li class="list">de fiscale partner werkt 525 uren of meer zonder vergoeding in je onderneming, of de
                    vergoeding
                    die de ondernemer hiervoor betaalt is minder dan € 5.000. De ondernemer moet het aantal
                    meegewerkte uren aannemelijk kunnen maken
                </li>
                <div class="space10"></div>

                Let op! Betaal je aan je fiscale partner een arbeidsbeloning van minder dan € 5.000? Dan mag je deze
                arbeidsbeloning niet aftrekken van de winst. de partner hoeft deze vergoeding ook niet aan te geven.
                <div class="space10"></div>

                Je krijgt geen meewerkaftrek over de winst die je behaalt als medegerechtigde.
                <div class="space10"></div>

                De meewerkaftrek wordt berekend op basis van de wint. Daarbij wordt niet meegeteld de
                winst die de ondernemer heeft behaald:
                <li class="list">bij onteigening</li>
                <li class="list">bij het (gedeeltelijk) staken van de onderneming</li>
                <li class="list">bij het overbrengen van vermogensbestanddelen naar het buitenland</li>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Stakingsaftrek
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Staakt de ondernemer de hele onderneming? Bijvoorbeeld doordat hij de onderneming verkoopt? Dan
                moet hij belasting betalen over de stakingswinst. Je mag de stakingsaftrek van de stakingswinst
                aftrekken. De aftrek is gelijk aan de
                stakingswinst, maar maximaal € 3.630.
                <div class="space10"></div>
                Je krijgt geen stakingsaftrek over de winst die je behaalt als medegerechtigde.
                <div class="space10"></div>
                Maakte de ondernemer eerder gebruik van de stakingsaftrek (vóór 2001 'stakingsvrijstelling')?
                Bijvoorbeeld doordat hij een deel van de onderneming heeft gestaakt? Dan geldt een afwijkende
                regeling. De stakingsaftrek wordt dan beperkt.

                <div class="space10"></div>
                Schuift de ondernemer een onderneming geruisloos door in verband met:
                <li class="list">echtscheiding</li>
                <li class="list">overdracht aan een medeondernemer</li>
                <li class="list">omzetting van de onderneming in een BV</li>
                En heeft de ondernemer een oudedagsreserve? Dan is er misschien stakingswinst omdat de
                oudedagsreserve (deels) vrijvalt. In dat geval kun je gebruikmaken van de stakingsaftrek.
                <div class="space10"></div>

                Let op! Je hebt geen recht op stakingsaftrek als de onderneming nog geen 3 jaar geruisloos is
                voortgezet.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                Aftrek voor speur- en ontwikkelingswerk
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="heading4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Een ondernemer krijgt de aftrek voor speur- en ontwikkelingswerk als hij voldoet aan alle
                volgende voorwaarden:
                <li class="list">hij is ondernemer voor de inkomstenbelasting.</li>
                <li class="list">hij voldoet aan het urencriterium.</li>
                <li class="list">hij heeft een S&O-verklaring van de Rijksdienst voor Ondernemend Nederland (RVO.nl)
                    waarin
                    staat dat de werkzaamheden onder speur- en ontwikkelingswerk vallen.
                </li>
                <li class="list">hij besteedt zelf minimaal 500 uren aan erkend speur- en ontwikkelingswerk.</li>
                <div class="space10"></div>

                Let op! Je krijgt geen aftrek voor speur- en ontwikkelingswerk over de winst die je behaalt als
                medegerechtigde of als geldverstrekker.

                <div class="space10"></div>
                <b>Verhoogde aftrek voor starters</b><br/>
                De aftrek wordt verhoogd in de volgende situatie:
                <li>de ondernemer was in 1 of meer van de 5 voorgaande kalenderjaren geen ondernemer.</li>
                <li>de ondenemer paste in deze periode niet meer dan 2 keer aftrek voor speur- en ontwikkelingswerk
                    toe.
                </li>
                <div class="space10"></div>
                De aftrek voor speur- en ontwikkelingswerk is een vast bedrag.

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading6">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse6" aria-expanded="false" aria-controls="collapse6">
                Stand fiscale oudedagsreserve
            </button>
        </h2>
        <div id="collapse6" class="accordion-collapse collapse" aria-labelledby="heading6"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Tot en met 2022 mocht je jaarlijks een deel van de winst reserveren voor de oudedagsvoorziening, de
                fiscale oudedagsreserve (FOR). Sinds 1 januari 2023 kun je geen oudedagsreserve meer vormen. Heb je een
                FOR op de balans staan? Dan blijven de regels gelden rond de afname van de reserve.
                <div class="space10"></div>
                Je mag geen bedragen meer toevoegen aan een bestaande FOR.
                <div class="space10"></div>
                <b>Afname oudedagsreserve</b><br/>
                In de volgende situaties neemt de oudedagsreserve af of wordt deze opgeheven:
                <li>je koopt een lijfrente voor een inkomensvoorziening, en je vermeldt in de aangifte de afname van de
                    oudedagsreserve voor hetzelfde bedrag.
                </li>
                <li>Het bedrag van de oudedagsreserve is hoger dan het ondernemingsvermogen, terwijl zich daarbij 1 van
                    de
                    volgende situaties voordoet:<br/>
                    - je staakt de onderneming geheel of gedeeltelijk.<br/>
                    - je hebt op 1 januari van het kalenderjaar de AOW-leeftijd bereikt.<br/>
                    - je voldoet dit kalenderjaar en het vorige kalenderjaar niet aan het urencriterium.
                </li>
                <div class="space10"></div>
                Een afname of opheffing van de oudedagsreserve betekent in principe dat je een hogere winst hebt. Maar
                daar tegenover staat de aftrek van het bedrag dat je betaalt bij de aankoop van een lijfrente.
                <div class="space10"></div>
                De regels rond de afname van de reserve blijven gelden na het afschaffen van de oudedagsreserve in 2023.
                <div class="space10"></div>
                <b>Staken van de onderneming</b><br/>
                Met het staken van de onderneming wordt de oudedagsreserve opgeheven. De bedragen waarover je uitstel
                van
                belastingheffing hebt gekregen, worden nu bij de winst opgeteld.
                <div class="space10"></div>
                <b>Overlijden van de ondernemer</b><br/>
                Als je overlijdt, moet fiscaal worden afgerekend over de oudedagsreserve. De reserve wordt dan opgeheven
                en wordt opgeteld bij de belastbare winst. Maar als je partner de onderneming voortzet en de
                oudedagsreserve overneemt, hoeft er niet te worden afgerekend. De partner moet daarvoor een verzoek
                indienen bij de aangifte.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading5">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
                Heffingskorting jonggehandicapten
            </button>
        </h2>
        <div id="collapse5" class="accordion-collapse collapse" aria-labelledby="heading5"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Heeft de ondernemer recht op een uitkering volgens de Wet arbeidsongeschiktheidsvoorziening
                jonggehandicapten (Wajong) of op ondersteuning bij het vinden van werk volgens de Wet Wajong? En
                krijgt hij geen 'ouderenkorting'? Dan krijgt hij wel de heffingskorting voor jonggehandicapten.
                <div class="space10"></div>

                De heffingskorting voor jonggehandicapten is geen onderdeel van de ondernemersaftrek, maar is
                een van de heffingskortingen welke de belasting vernminderen.
            </div>
        </div>
    </div>

</div>

